import axios from "axios";

import {
  RetargetingRule,
  RetargetingRuleNodeRoot,
} from "../types/retargeting-rule";

export interface CreateRetargetingRuleData {
  name: string;
  rules: RetargetingRuleNodeRoot;
  "fb-ad-account-id": string;
}

export const createRetargetingRule = async (
  workspaceSlug: string,
  data: CreateRetargetingRuleData,
): Promise<RetargetingRule> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/retargeting-rules`,
      data,
    )
  ).data;
};

export const getRetargetingRules = async (
  workspaceSlug: string,
): Promise<{ total: number; rules: RetargetingRule[] }> => {
  return (
    await axios.get(`/api/v1/workspaces/${workspaceSlug}/retargeting-rules`)
  ).data;
};

export const getRetargetingRule = async (
  workspaceSlug: string,
  id: number,
): Promise<RetargetingRule> => {
  return (
    await axios.get(
      `/api/v1/workspaces/${workspaceSlug}/retargeting-rules/${id}`,
    )
  ).data;
};

export const updateRetargetingRule = async (
  workspaceSlug: string,
  rule: RetargetingRule,
): Promise<RetargetingRule> => {
  return (
    await axios.put(
      `/api/v1/workspaces/${workspaceSlug}/retargeting-rules/${rule.id}`,
      rule,
    )
  ).data;
};

export const deleteRetargetingRule = async (
  workspaceSlug: string,
  id: number,
): Promise<void> => {
  await axios.delete(
    `/api/v1/workspaces/${workspaceSlug}/retargeting-rules/${id}`,
  );
};
